import { atom } from 'recoil'

export const formDataAtom = atom({
    key: 'formData',
    default: {},
})
export const formSectionFieldValueViewAtom = atom({
    key: 'formSectionFieldValueView',
    default: {},
})

export const formSectionFieldOptionAtom = atom({
    key: 'formSectionFieldOption',
    default: {},
})

export const formFieldGroupAtom = atom({
    key: 'formFieldGroup',
    default: {},
})

export const savingAtom = atom({
    key: 'saving',
    default: false,
})

export const saveTimeAtom = atom ({
    key: 'savingTime',
    default: null,
})

export const baseDataAtom = atom ({
    key: 'baseData',
    default: null,
})

